module.exports = __webpack_public_path__ + "img/kep2-3.c419d3f4.jpg";